const DollarCoinSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_11466_243993)">
      <g filter="url(#filter0_iii_11466_243993)">
        <circle cx="8" cy="8" r="8" fill="#FFA500" />
      </g>
      <circle cx="8" cy="8" r="7.5" stroke="url(#paint0_linear_11466_243993)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5932 4.47059C9.67797 4.0084 9.01695 3.88235 8.45763 3.84034V3H7.23729V3.92437C6.0678 4.17647 5.15254 4.89076 5.15254 6.02521C5.15254 7.07563 5.81356 7.70588 7.59322 8.42017C9.11864 9.05042 9.52542 9.2605 9.52542 9.89076C9.52542 10.563 8.91525 11.1513 7.8983 11.1513C7.13559 11.1513 6.57627 10.9412 5.66102 10.3529L5 11.3613C5.45763 11.6134 6.16949 11.9916 7.23729 12.1176V13H8.45763V12.0756C9.98305 11.9076 11 10.9832 11 9.72269C11 8.37815 9.72881 7.87395 9.22034 7.66387L7.64407 6.9916C7.08475 6.78151 6.52542 6.44538 6.52542 5.85714C6.52542 5.35294 6.9322 4.80672 7.94915 4.80672C8.91525 4.80672 9.37288 5.14286 10.1356 5.56303L10.5932 4.47059Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_iii_11466_243993"
        x="-1"
        y="-1"
        width="18"
        height="18"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1" dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.841374 0 0 0 0 0.544418 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_11466_243993" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1" dy="-2" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.843137 0 0 0 0 0.545098 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_11466_243993"
          result="effect2_innerShadow_11466_243993"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-3" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_11466_243993"
          result="effect3_innerShadow_11466_243993"
        />
      </filter>
      <linearGradient
        id="paint0_linear_11466_243993"
        x1="4"
        y1="1.81818"
        x2="10.9091"
        y2="15.2727"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA500" />
        <stop offset="1" stopColor="#E99803" />
      </linearGradient>
      <clipPath id="clip0_11466_243993">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default DollarCoinSvg;
